import { Button, Typography } from '@mui/material';
import { styled } from '@mui/styles';
import React from 'react';

const ButtonYes = styled(Button)({
  marginRight: '6px',
  minWidth: '130px',
});

const ButtonCancel = styled(ButtonYes)({
  background: '#EBECF0!important',
});

function PopupSave({ onCancel, onConfirm }) {
  return (
    <div className='rounded-lg w-80 h-40 px-6 py-2'>
      <Typography variant='body1' className='my-2 text-xl' style={{ color: '#343C63' }}>
        Save
      </Typography>
      <Typography variant='body2' style={{ color: '#7A7F9A' }} className='my-2 text-neutral-100 mb-6 text-sm'>
        Do you want to save your edit?
      </Typography>
      <ButtonCancel onClick={onCancel}>Cancel</ButtonCancel>
      <ButtonYes onClick={onConfirm}>Yes, continue</ButtonYes>
    </div>
  );
}

export default PopupSave;
